import React, { Component } from 'react';
import LOOKUP from 'constants/lookup';
import Button from './Button';
import DialogInput from '../advanced/DialogInput';
import DialogHeaderWithClose from './DialogHeaderWithClose';

class DialogConfirm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isOpen: false
        };
    }

    componentWillMount() {
        this.setState({ isOpen: this.props.isOpen });
    }

    componentWillReceiveProps(newProps) {
        if (this.state.isOpen !== newProps.isOpen) {
            this.setState({ isOpen: newProps.isOpen });
        }
    }

    closeDialog = () => {
        this.setState({ isOpen: false });
        this.props.onCancel();
    }

    confirm = () => {
        this.setState({ isOpen: false });
        this.props.onConfirm();
    }

    render() {
        const p = this.props;
        const s = this.state;
        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={p.title} handleClose={() => this.closeDialog()} />}
                    actions={[
                        <Button
                            key={2}
                            id="ConfirmButton"
                            name="ConfirmButton"
                            label={LOOKUP.common.confirm.text}
                            primary={true}
                            onTouchTap={() => this.confirm()} />]}
                    modal={true}
                    open={s.isOpen}>
                    {p.message}
                </DialogInput>
            </div>
        );
    }
}

export default DialogConfirm;